import { useAuthStore } from "../store/auth.store";
import { useEffect, useState } from "react";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { useDashboardStore } from "../store/dashboard.store";
import { useDashboard } from "../hook/partner/dashboard.partner.hook";
import { useOpportunitiesTableStore } from "../store/opportunitiesTable.store";
import OpportunityTable from "../components/Opportinuty/OpportunityTable";
import InvoiceTable from "../components/Invoice/InvoiceTable";
import { useInvoicesTableStore } from "../store/invoicesTable.store";
import { NavLink } from "react-router";
import { PartnerApi } from "../api/partner.api";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import number_format from "../utils/number_format";
import ShippingDetailModal from "../components/modals/shipping/ShippingDetailModal";
import OpportunityNewModal from "../components/modals/opportunity/OpportunityNewModal";
import LoanNewModal from "../components/modals/loan/LoanNewModal";
import Modal from "../components/modals/Modal";
import { useTranslation } from "../hooks/useTranslation";

function Dashboard() {
  const { t } = useTranslation();
  const dashboardMutation = useDashboard();

  const [showShippingDetailModal, setShowShippingDetailModal] = useState(false);
  const [showOpportunityNewModal, setShowOpportunityNewModal] = useState(false);
  const [showLoanNewModal, setShowLoanNewModal] = useState(false);

  const token = useAuthStore((state) => state.token);
  const isInternalAdmin = useAuthStore((state) => state.isInternalAdmin());
  const dashboard = useDashboardStore((state) => state.dashboard);
  const [showModal, setShowModal] = useState(false);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);

  const getAvailableColumnsInvoices = useInvoicesTableStore((state) => state.getAvailableColumns);
  const awailableColumnsInvoices = getAvailableColumnsInvoices();
  const getAvailableColumnsOpportunities = useOpportunitiesTableStore((state) => state.getAvailableColumns);
  const awailableColumnsOpportinuties = getAvailableColumnsOpportunities();

  const [shippingInfo, setShippingInfo] = useState(null);

  Chart.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
  );

  useEffect(() => {
    setPagename(t("navigation.dashboard"));
    setBreadcrumbs([]);
  }, []);

  useEffect(() => {
    if (token) {
      dashboardMutation.mutate({ token });
    }
  }, [token]);

  console.log(dashboard);

  const selectedColumnsOpportinuties = [
    "opportunity_id",
    "description",
    "create_date",
    "exn_person",
    "current_state",
    "purchase_total_amount_local_currency",
  ];

  const selectedColumnsInvoices = [
    "invoice_number",
    "total_amount_currency",
    "status",
  ];

  const pieChart = (data, totalText) => {
    let numbers = [];
    let colors = [];
    let labels = [];
    let i = 0;
    let sum = 0;
    console.log("data", data);
    if (!data || data === false) {
      numbers = [100];
      colors = ["#f0f0f0"];
      labels = [t("common.nothingFound")];
    } else {
      for (i = 0; i < data.length; i++) {
        numbers.push(data[i].value);
        sum += data[i].value;
        colors.push(data[i].color);
        labels.push(data[i].description);
      }
    }
    if (sum === 0) {
      numbers = [100];
      colors = ["#f0f0f0"];
      labels = [t("common.nothingFound")];
    }
    const match = totalText
      ? totalText.match(/([0-9.]+[A-Za-z]+)\s([A-Za-z]+)/)
      : [];
    return (
      <div style={{ position: "relative", height: "100%", width: "100%" }}>
        <Doughnut
          data={{
            labels: labels,
            datasets: [
              {
                data: numbers,
                backgroundColor: colors,
                borderWidth: 0,
              },
            ],
          }}
          options={{
            responsive: true,
            cutout: "70%",
            rotation: 225,
            circumference: 270,
            plugins: {
              tooltip: {
                enabled: true,
              },
              legend: {
                display: false,
              },
            },
          }}
        />
        <div
          style={{
            position: "absolute",
            left: "25%",
            top: "50%",
            width: "50%",
            textAlign: "center",
            fontSize: "2em",
            fontWeight: "bold",
          }}
        >
          {match ? (
            <>
              <div>{match[1]}</div>
              <div style={{ fontSize: "0.7em", color: "#aaa" }}>{match[2]}</div>
            </>
          ) : (
            totalText
          )}
        </div>
      </div>
    );
  };

  const barChart = (data) => {
    let color = [
      "#D1B375",
      "#a1237f",
      "#B8E2B6",
      "#A3D8F4",
      "#F7B7D6",
      "#F8E0A1",
      "#D1B375",
      "#a1237f",
      "#B8E2B6",
      "#A3D8F4",
      "#F7B7D6",
      "#F8E0A1",
      "#D1B375",
      "#a1237f",
      "#B8E2B6",
      "#A3D8F4",
      "#F7B7D6",
      "#F8E0A1",
      "#D1B375",
      "#a1237f",
      "#B8E2B6",
      "#A3D8F4",
      "#F7B7D6",
      "#F8E0A1",
      "#D1B375",
      "#a1237f",
      "#B8E2B6",
      "#A3D8F4",
      "#F7B7D6",
      "#F8E0A1",
    ];
    let datasets = [];
    let labels = [];
    let numbers = [];
    let i = 0;
    let j = 0;
    for (i = 0; i < data.length; i++) {
      numbers = [];
      console.log("x", data[i]);
      for (j = 0; j < data[i].data.length; j++) {
        if (i == 0) {
          labels.push(data[i].data[j].description);
        }
        numbers.push(data[i].data[j].value);
      }
      datasets.push({
        label: data[i].datasetName,
        data: numbers,
        backgroundColor: color[i],
        borderWidth: 0,
      });
    }
    return (
      <Bar
        data={{ labels, datasets }}
        options={{
          responsive: true,
          height: "400px",
          maintainAspectRatio: true,
          scales: {
            x: {
              stacked: true,
            },
            y: { stacked: true },
            xAxes: [
              {
                barThickness: 35,
                maxBarThickness: 40,
                categoryPercentage: 0.5,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            },
            tooltip: { enabled: true },
          },
        }}
      />
    );
  };

  return (
    <>
      {dashboard !== null && (
        <div className="row">
          {dashboard.elements?.length > 0 &&
            dashboard.elements?.map((el, i) => (
              <>
                {el.type === "adminList" && (
                  <div className="col-md-6 col-lg-4">
                    <h2 className="mb-4">{el.name}</h2>
                    <div className="card mb-8">
                      <div className="card-body pt-4">
                        <div className="text-center border-bottom pb-3">
                          {el.description}
                        </div>
                        {el.data && el.data.length > 0 ? (
                          <ul className="mt-5">
                            {el.data.map((admin) => (
                              <li>
                                {admin.jmeno} {admin.prijmeni}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <div className="alert alert-danger mt-3">
                            {t("company.noAdminSet")}:{" "}
                            <a href="mailto:adela.docekalova@exclusive-networks.cz">
                              adela.docekalova@exclusive-networks.cz
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {el.type === "pieChart" && (
                  <div className="col-md-6 col-lg-4">
                    <h2 className="mb-4">{el.name}</h2>
                    <div className="card mb-8">
                      <div className="card-body pt-4">
                        <div className="text-center border-bottom pb-3">
                          {el.description}
                        </div>
                        <div
                          xclassName="ps-7 pe-7"
                          style={{
                            margin: "0px auto",
                            width: "250px",
                            height: "250px",
                          }}
                        >
                          {pieChart(el.data.data, el.data.total_text)}
                        </div>
                        <div style={{ height: "75px" }}>
                          {el.message && (
                            <div className="alert alert-danger">
                              {el.message}
                            </div>
                          )}
                          {el.data?.data?.map((d) => (
                            <div className="row pt-2">
                              <div className="col-8">
                                <span
                                  style={{
                                    color: d.color,
                                    fontSize: "1.6em",
                                    lineHeight: "0.9em",
                                  }}
                                >
                                  &#9679;
                                </span>{" "}
                                {d.link ? (
                                  <NavLink to={d.link}>{d.description}</NavLink>
                                ) : (
                                  d.description
                                )}
                              </div>
                              <div className="col-4 text-end">
                                {number_format(d.value, 0, ",", ".")}
                                {d.unit && (
                                  <span className="fs-8 ms-1 text-muted">
                                    {d.unit}
                                  </span>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="card-footer">
                        <NavLink to={el.link} className="btn btn-primary w-100">
                          {el.name}
                        </NavLink>
                      </div>
                    </div>
                  </div>
                )}
                {el.type === "salesChart" && (
                  <div className="col-lg-8">
                    <h2 className="mb-4">{el.name}</h2>
                    <div className="card mb-8">
                      <div
                        className="card-body"
                        style={{ width: "100%", aspectRatio: "3/1.5" }}
                      >
                        {barChart(el.data)}
                      </div>
                      <div className="card-footer text-center">
                        <NavLink to={el.link} className="btn btn-primary w-100">
                          {el.name}
                        </NavLink>
                      </div>
                    </div>
                  </div>
                )}
                {el.type === "opportunity" && (
                  <div className="col-12">
                    <h2 className="mb-4">{el.name}</h2>
                    {el.data?.length > 0 ? (
                      <div className="card mb-8">
                        <div className="card-body pt-0">
                          <OpportunityTable
                            opportunities={el}
                            awailableColumns={awailableColumnsOpportinuties}
                            selectedColumns={selectedColumnsOpportinuties}
                            checkbox={false}
                          />
                        </div>
                      </div>
                    ) : (
                      <p className=" mb-8">{t("common.none")}</p>
                    )}
                  </div>
                )}

                {el.type === "invoice" && (
                  <div className="col-12 col-md-6">
                    <h2 className="mb-4">{el.name}</h2>

                    {el.data?.length > 0 ? (
                      <div className="card mb-8">
                        <div className="card-body pt-0">
                          <InvoiceTable
                            invoices={el}
                            awailableColumns={awailableColumnsInvoices}
                            selectedColumns={selectedColumnsInvoices}
                            token={token}
                            checkbox={false}
                          />
                        </div>
                      </div>
                    ) : (
                      <p className=" mb-8">{t("common.none")}</p>
                    )}
                  </div>
                )}
                {el.type === "links" && (
                  <div className="col-12 col-md-6 col-lg-4">
                    <h2 className="mb-4">{el.name}</h2>
                    <OpportunityNewModal
                      show={showOpportunityNewModal}
                      handleClose={() => setShowOpportunityNewModal(false)}
                    />
                    <LoanNewModal
                      show={showLoanNewModal}
                      handleClose={() => setShowLoanNewModal(false)}
                    />
                    <div className="row">
                      {el.data?.length > 0 &&
                        el.data?.map((link, i) => (
                          <div className="col-4 mb-6 text-center ">
                            {link.modal ? (
                              <a
                                href="javascript:;"
                                onClick={() =>
                                  link.modal === "newOpportunity"
                                    ? setShowOpportunityNewModal(true)
                                    : setShowLoanNewModal(true)
                                }
                                className="card p-4 h-100"
                              >
                                <span
                                  className={
                                    "fs-3x mx-auto mb-4 ki-duotone ki-" +
                                    link.icon
                                  }
                                >
                                  <span className="path1"></span>
                                  <span className="path2"></span>
                                  <span className="path3"></span>
                                  <span className="path4"></span>
                                  <span className="path5"></span>
                                </span>
                                {link.title}
                              </a>
                            ) : (
                              <NavLink
                                to={link.href}
                                key={i}
                                className="card p-4 h-100"
                              >
                                <span
                                  className={
                                    "fs-3x mx-auto mb-4 ki-duotone ki-" +
                                    link.icon
                                  }
                                >
                                  <span className="path1"></span>
                                  <span className="path2"></span>
                                  <span className="path3"></span>
                                  <span className="path4"></span>
                                  <span className="path5"></span>
                                </span>
                                <span>{link.title}</span>
                              </NavLink>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                )}
                {el.type === "shipping" && (
                  <div className="col-12 col-lg-8 col-md-6">
                    {isInternalAdmin ? (
                        <>
                          <h2 className="mb-4">{el.name}</h2>

                          <div className="card mb-8">
                            <div className="card-body">
                              {("datav2" in el && el.datav2?.length > 0) ? (
                                  <>

                                  <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable d-none d-lg-table">
                                    <thead>
                                    <tr>
                                      <th>{t("shipping.client")}</th>
                                      <th>{t("shipping.currentState")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {el.datav2.map((d) => (
                                        <tr>
                                          <td valign="top">
                                              <div>
                                                <NavLink
                                                    to={
                                                        "/prilezitost/" + d.opportunity_id
                                                    }
                                                    className="me-3"
                                                >
                                                  {d.company_name}
                                                </NavLink><br/>
                                                <small>
                                                {d.partner_order_id}
                                                </small>
                                              </div>
                                          </td>
                                          <td>

                                            {"moreInfo" in d.data[0][3] && (
                                                <Modal title={t("shipping.packageDetail")} show={showModal===d.opportunity_id} handleClose={()=>setShowModal(false)}>
                                                  <div dangerouslySetInnerHTML={{__html: d.data[0][3].moreInfo}}></div>
                                                </Modal>
                                            )}

                                            {d.data.map((deliveryInfo) => (
                                                <>
                                                <div className="delivery-line delivery-line--mini mb-2">
                                                  {deliveryInfo[0] != null && "status" in deliveryInfo[0] && (
                                                      <div className={"delivery-line__item is-" + deliveryInfo[0].status}>
                                                        <h2 className="delivery-line__item__title">{t("shipping.exclusiveNetworks")}</h2>
                                                        <div className="delivery-line__item__icon">
                                                          <i className="ki-outline ki-tablet-text-up"></i>
                                                        </div>
                                                      </div>
                                                  )}

                                                  {deliveryInfo[1] != null && "status" in deliveryInfo[1] && (
                                                      <div className={"delivery-line__item is-" + deliveryInfo[1].status}>
                                                        <h2 className="delivery-line__item__title">{t("shipping.warehouseTw")}</h2>
                                                        <div className="delivery-line__item__icon">
                                                          <i className="ki-outline ki-logistic"></i>
                                                          <i className="ki-outline ki-arrow-right"></i>
                                                        </div>
                                                      </div>
                                                  )}

                                                  {deliveryInfo[2] != null && "status" in deliveryInfo[2] && (
                                                      <div className={"delivery-line__item is-" + deliveryInfo[2].status}>
                                                        <h2 className="delivery-line__item__title">{t("shipping.shippingDhl")}</h2>
                                                        <div className="delivery-line__item__icon">
                                                          <i className="ki-outline ki-airplane"></i>
                                                          <i className="ki-outline ki-arrow-right"></i>
                                                        </div>
                                                      </div>
                                                  )}

                                                  {deliveryInfo[3] != null && "status" in deliveryInfo[3] && (
                                                      <div className={"delivery-line__item is-" + deliveryInfo[3].status}>
                                                        <h2 className="delivery-line__item__title">{t("shipping.glsJl")}</h2>
                                                        <div className="delivery-line__item__icon">
                                                          <i className="ki-outline ki-delivery"></i>
                                                          <i className="ki-outline ki-arrow-right"></i>
                                                        </div>
                                                      </div>
                                                  )}

                                                  {deliveryInfo[4] != null && "status" in deliveryInfo[4] && (
                                                      <div className={"delivery-line__item is-" + deliveryInfo[4].status}>
                                                        <h2 className="delivery-line__item__title">{t("shipping.partnerCustomer")}</h2>
                                                        <div className="delivery-line__item__icon">
                                                          <i className="ki-outline ki-home"></i>
                                                          <i className="ki-outline ki-arrow-right"></i>
                                                        </div>
                                                      </div>
                                                  )}
                                                </div>
                                                  {/*
                                                  {deliveryInfo[0] != null && "status" in deliveryInfo[0] && (
                                                      <div className="delivery-line__item__text">
                                                          {deliveryInfo[0].text}
                                                      </div>
                                                  )}
                                                  {deliveryInfo[1] != null && "status" in deliveryInfo[1] && (
                                                      <div className="delivery-line__item__text">
                                                          {deliveryInfo[1].text}
                                                      </div>
                                                  )}
                                                  {deliveryInfo[2] != null && "status" in deliveryInfo[2] && (
                                                      <div className="delivery-line__item__text">
                                                          {deliveryInfo[2].text}
                                                      </div>
                                                  )}
                                                  {deliveryInfo[3] != null && "status" in deliveryInfo[3] && (
                                                      <div className="delivery-line__item__text text-center">
                                                        <a href="javascript:;"
                                                           onClick={() => setShowModal(d.opportunity_id)}>
                                                          {deliveryInfo[3].text}
                                                        </a>
                                                      </div>
                                                  )}
                                                  {deliveryInfo[4] != null && "status" in deliveryInfo[4] && (
                                                      <div className="delivery-line__item__text text-center">
                                                        <a href="javascript:;"
                                                           onClick={() => setShowModal(d.opportunity_id)}>
                                                          {deliveryInfo[4].text}
                                                        </a>
                                                      </div>
                                                  )}
                                                  */}
                                                </>
                                            ))}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                    </>
                                  ) : (
                                  <div className="alert alert-danger">
                                    {t("shipping.noShipments")}
                                  </div>
                              )}
                            </div>
                          </div>
                        </>
                    ) : (
                        <>
                          <ShippingDetailModal
                              show={showShippingDetailModal}
                              handleClose={() => setShowShippingDetailModal(false)}
                              tracking_id={shippingInfo?.tracking_id}
                              shipping_company={shippingInfo?.shipping_company}
                          />
                          <h2 className="mb-4">{el.name}</h2>
                          <div className="card mb-8">
                            <div className="card-body">
                              {el.data?.length > 0 ? (
                                  <>
                                    <div className="d-lg-none">
                                      {el.data.map((d) => (
                                          <div className="row border-top mt-2 pt-2">
                                            <div className="col-8">
                                              <div>
                                                {d.tracking_id}{" "}
                                                <span className="badge badge-primary badge-outline">
                                        {d.shipping_company}
                                      </span>
                                              </div>
                                              <div>
                                                {" "}
                                                {d.opportunities.map((o) => (
                                                    <div>
                                                      <NavLink
                                                          to={
                                                              "/prilezitost/" + o.opportunity_id
                                                          }
                                                          className="me-3"
                                                      >
                                                        PR{o.opportunity_id}:{" "}
                                                        {o.company_name}
                                                      </NavLink>
                                                    </div>
                                                ))}
                                              </div>
                                            </div>
                                            <div className="col-4 text-end">
                                              <button
                                                  className="btn btn-sm btn-primary"
                                                  onClick={() => {
                                                    setShowShippingDetailModal(true);
                                                    setShippingInfo({
                                                      tracking_id: d.tracking_id,
                                                      shipping_company: d.shipping_company,
                                                    });
                                                  }}
                                              >
                                                {t("common.detail")}
                                              </button>
                                            </div>
                                          </div>
                                      ))}
                                    </div>
                                    <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable d-none d-lg-block">
                                      <thead>
                                      <tr>
                                        <th>{t("shipping.client")}</th>
                                        <th>{t("shipping.trackingId")}</th>
                                        <th>{t("shipping.currentState")}</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      {el.data.map((d) => (
                                          <tr>
                                            <td>
                                              {d.opportunities.map((o) => (
                                                  <div>
                                                    <NavLink
                                                        to={
                                                            "/prilezitost/" + o.opportunity_id
                                                        }
                                                        className="me-3"
                                                    >
                                                      {o.company_name}
                                                    </NavLink>
                                                  </div>
                                              ))}
                                            </td>
                                            <td>
                                              <a
                                                  href="javascript:;"
                                                  onClick={() => {
                                                    setShowShippingDetailModal(true);
                                                    setShippingInfo({
                                                      tracking_id: d.tracking_id,
                                                      shipping_company:
                                                      d.shipping_company,
                                                    });
                                                  }}
                                              >
                                                {d.tracking_id}{" "}
                                                <span className="badge badge-primary badge-outline">
                                          {d.shipping_company}
                                        </span>
                                              </a>
                                            </td>
                                            <td
                                                className={
                                                  d.status_code === "delivered"
                                                      ? "text-success"
                                                      : "text-info"
                                                }
                                            >
                                              <strong>{d.status_description}</strong>
                                              {d.status_code === "delivered" &&
                                                  " " +
                                                  new Date(
                                                      d.time_of_delivery
                                                  ).toLocaleDateString()}
                                            </td>
                                          </tr>
                                      ))}
                                      </tbody>
                                    </table>
                                  </>
                              ) : (
                                  <div className="alert alert-danger">
                                    {t("shipping.noShipments")}
                                  </div>
                              )}
                            </div>
                          </div>
                        </>
                    )}
                  </div>
                )}
                {el.type === "vendors" && (
                  <div className="col-12 col-md-4">
                    <h2 className="mb-4">{el.name}</h2>

                    <div className="row">
                      {el.data?.length > 0 &&
                        el.data?.map((vendor, i) => (
                          <div className="col-4 mb-6 text-center ">
                            <NavLink
                              to={`/produkty/${vendor.vendor_id}`}
                              className={
                                "card p-5 d-flex justify-content-center align-items-center h-100"
                              }
                            >
                              <img
                                className="mw-100"
                                style={{
                                  aspectRatio: "1 / 1",
                                  objectFit: "contain",
                                }}
                                src={
                                  PartnerApi.url +
                                  "/vendor/" +
                                  vendor.vendor_id +
                                  "/logo.jpg"
                                }
                                alt={vendor.name}
                              />
                            </NavLink>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            ))}
        </div>
      )}
    </>
  );
}

export default Dashboard;
